/**
 * Normalize ticket status from API (e.g. "in process", "in_process", "InProcess") to a single key for filters/UI.
 */
export function normalizeSupportTicketStatus(raw: string | undefined): string {
  return String(raw || '')
    .toLowerCase()
    .trim()
    .replace(/[\s_-]/g, '')
}

/** Normalize search input (e.g. "#42" → "42") for ticket id / email matching. */
export function normalizeTicketSearchQuery(raw: string): string {
  let q = raw.trim().toLowerCase()
  if (q.startsWith('#')) q = q.slice(1).trim()
  return q
}

/** Match ticket list row against search (ticket id, uuid, user email). */
export function ticketMatchesIdOrEmailSearch(
  ticket: { id?: number | string; uuid?: string; user_email?: string },
  rawQuery: string
): boolean {
  const q = normalizeTicketSearchQuery(rawQuery)
  if (!q) return true
  const idStr = String(ticket.id ?? '')
  const uuidStr = String(ticket.uuid ?? '').toLowerCase()
  const emailStr = String(ticket.user_email ?? '').toLowerCase()
  return idStr.includes(q) || uuidStr.includes(q) || emailStr.includes(q)
}

export function normalizeSupportTicketPriority(raw: string | undefined): string {
  return String(raw || '')
    .toLowerCase()
    .trim()
}
